/** @description 自定义edge */

import React, { useMemo } from 'react';
import { getBezierPath, EdgeProps } from 'react-flow-renderer';
import { useSelector } from 'umi';
import { Tooltip } from 'antd';

const CustomEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  selected,
  label: l,
  labelBgStyle,
  source,
  target
}) => {
  const label = l as string;
  const selectedNode = useSelector((state: any) => state.open.selectedNode);
  const selectedEdge = useSelector((state: any) => state.open.selectedEdge);

  const formatLabel = useMemo(() => {
    if (label?.length > 24) {
      return `${label.slice(0, 10)}...${label.slice(-10)}`;
    }
    return label;
  }, [label]);

  const edgePath = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const yOffset = Math.abs(targetY - sourceY) / 2;
  const centerY = targetY < sourceY ? targetY + yOffset : targetY - yOffset;

  const xOffset = Math.abs(targetX - sourceX) / 2;
  const centerX = targetX < sourceX ? targetX + xOffset : targetX - xOffset;


  let stroke = '#56595F';
  let opacity = selected ? 1 : 0.8;
  const strokeWidth = (selected || (selectedNode === source || selectedNode === target)) ? 4 : 2;
  if (selectedNode) opacity = (selectedNode === source || selectedNode === target) ? 1 : 0.2;
  if (selectedEdge && selectedEdge !== id) opacity = 0.2;


  const foreignObjectWidth = 250;
  const foreignObjectHeight = 28;

  const wrapperStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    opacity,
  } as React.CSSProperties;

  const labelStyle = {
    background: 'rgba(255, 255, 255, 0.9)',
    padding: '0px 4px',
    lineHeight: `${foreignObjectHeight}px`,
    borderRadius: 4,
    fontSize: 16, 
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#333'
  } as React.CSSProperties;

  return (
    <>
      <path
        id={id}
        style={{ strokeWidth, stroke, opacity }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      {label && <foreignObject
        width={foreignObjectWidth}
        height={foreignObjectHeight}
        x={centerX - foreignObjectWidth / 2}
        y={centerY - foreignObjectHeight / 2}
      >
        <div style={wrapperStyle}>
          <Tooltip 
            color="rgba(255, 255, 255, 0.9)"
            title={() => <span style={{ color: '#333' }}>{label}</span>}
          >
            <div style={labelStyle}>{ formatLabel }</div>
          </Tooltip>
        </div>
      </foreignObject>}
    </>
  );
}

export default React.memo(CustomEdge);